/**
 * Created by Ivan on 25.02.2026
 */

const IslandDecorationMerge2Adapter = {
    SubscribeToEvents: function () {
        if (!cleverapps.config.features.includes("island_decoration")) {
            return;
        }

        const update = (mission) => {
            if (mission.getType() === Mission.TYPE_ISLAND_DECORATION) {
                cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
                cleverapps.eventBus.trigger("merge2CustomersForceUpdateReward");

                if (typeof IslandDecorationChest === "undefined") {
                    return;
                }

                if (mission.isRunning()) {
                    IslandDecorationChest.createOnScene(mission);
                } else {
                    IslandDecorationChest.removeFromScene();
                }
            }
        };

        cleverapps.missionManager.on("add", update);
        cleverapps.missionManager.on("complete", update);
        cleverapps.missionManager.on("addPointsChest", () => {
            const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_ISLAND_DECORATION);
            if (mission) {
                IslandDecorationChest.createOnScene(mission);
            }
        });

        cleverapps.missionManager.on("showPointsSources", (mission) => {
            if (mission.getType() !== Mission.TYPE_ISLAND_DECORATION) {
                return;
            }

            Merge2.current.changeMode(Merge2.MODE_GAME, () => {
                const customersList = Merge2.current.customers.listCustomersWithRecipe().filter((customer) => !customer.recipe.sideQuest);
                if (!customersList.length) {
                    return;
                }

                const customersWithReward = customersList.filter((customer) => {
                    const prizes = customer.recipe.prizesToRewards();

                    if (!prizes.mission) {
                        return false;
                    }

                    return prizes.mission.filter((mission) => mission.missionType === Mission.TYPE_ISLAND_DECORATION && mission.amount > 0).length;
                });

                const customer = customersWithReward.length ? customersWithReward[0] : customersList[0];
                const customerView = customer.onGetView();
                FingerView.hintTap(customerView, {
                    runOnce: true
                });

                cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).ordersTable.scrollToRow(customer.recipe.index);
            });
        });
    }
};

cleverapps.whenAllInitialized(() => IslandDecorationMerge2Adapter.SubscribeToEvents());
